import { Dropdown, FormField, listItemSelectBuilder } from '@wix/design-system';
import React, { useMemo, useState } from 'react';
import { RuleFooter } from '../../../../..';
export const HeadingStructureRuleRegularContent = _ref => {
  let {
    headingDefinition,
    failedReason,
    showLoader,
    elementIndex,
    status,
    texts,
    callbacks,
    dataHook
  } = _ref;
  const [value, setValue] = useState(headingDefinition.toLowerCase());
  const optionsForRender = useMemo(() => texts.dropdownOptions.map(_ref2 => {
    let {
      id,
      label
    } = _ref2;
    return listItemSelectBuilder({
      id,
      label,
      size: 'small',
      title: label
    });
  }), [texts.dropdownOptions]);
  const handleDropdownOpen = () => {
    callbacks.onDropdownOpen({
      index: elementIndex,
      status
    });
  };
  const handleSelect = option => {
    setValue(option.id);
    callbacks.onFieldChange({
      fieldName: 'HeadingTag',
      index: elementIndex,
      status,
      value: option.id
    });
  };
  const handleApply = () => {
    callbacks.onElementApply({
      index: elementIndex,
      status,
      value
    });
  };
  const handleCancel = () => {
    callbacks.onElementCancel({
      index: elementIndex,
      status
    });
  };
  const getErrorMessage = () => {
    if (!failedReason) {
      return undefined;
    }
    return texts.errors[failedReason];
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormField, {
    dataHook: dataHook ? `${dataHook}-form-field` : undefined,
    label: texts.dropdownLabel,
    labelSize: "tiny",
    status: failedReason ? 'error' : undefined,
    statusMessage: getErrorMessage()
  }, /*#__PURE__*/React.createElement(Dropdown, {
    dataHook: dataHook ? `${dataHook}-dropdown` : undefined,
    disabled: showLoader,
    options: optionsForRender,
    popoverProps: {
      appendTo: 'window',
      zIndex: 2000
    },
    selectedId: value,
    size: "small",
    valueParser: option => option.label,
    onOptionsShow: handleDropdownOpen,
    onSelect: handleSelect
  })), /*#__PURE__*/React.createElement(RuleFooter, {
    dataHook: dataHook ? `${dataHook}-footer` : undefined,
    dismissButtonProps: {
      label: texts.cancelButtonLabel,
      onClick: handleCancel,
      type: 'button'
    },
    submitButtonProps: {
      disabled: value === headingDefinition.toLowerCase(),
      label: texts.applyButtonLabel,
      onClick: handleApply,
      showLoader
    }
  }));
};
//# sourceMappingURL=heading-structure-rule-regular-content.js.map